import { render, staticRenderFns } from "./admin-areas.vue?vue&type=template&id=d1cab74a"
import script from "./admin-areas.vue?vue&type=script&lang=js"
export * from "./admin-areas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports